<ol class="list-unstyled mb-0">
    <li class="mb-3"><a routerLink="/videos/{{data.friendlyUrl}}">{{data.title}}</a></li>
  </ol>